<template>
  <div class="course-rating">
    <span v-if="!noValue" class="rating">{{ rating }}/5</span>
    <RatingStars :rating="rating" />
    <span v-if="reviews.ratings" class="ratings">({{ (reviews.ratings || 0).toLocaleString() }})</span>
  </div>
</template>

<script>
import RatingStars from './RatingStars';

export default {
  components: { RatingStars },
  props: {
    noValue: { type: Boolean },
    reviews: { type: Object, default: () => ({}) },
  },
  computed: {
    rating() {
      if (!this.reviews.rating) {
        return 0;
      }

      const rating = parseFloat(this.reviews.rating.toFixed(2));

      if (rating % 1 === 0) {
        return rating.toFixed(0);
      }

      return rating.toFixed(1);
    },
  },
};
</script>

<style lang="scss">
.course-rating {
  font-size: 14px;
  font-weight: 600;
  display: flex;
  align-items: center;
  height: 28px;

  .rating {
    margin-right: var(--spacing-4);
  }

  .ratings {
    margin-left: var(--spacing-4);
    font-weight: 500;
    color: var(--main-dark-light-4);
  }
}
</style>
